import { InitialAppDataResponse } from "../../../common/api/Models/types";
import {useAxiosGet} from "../../../infrastructure/http";

export function useGetInitialAppData(countryCode?: string, physicalLocationId?: number, manual?: boolean) {
	let query: string[] = [];
	if (countryCode) query.push("countryCode=" + countryCode);
	if (physicalLocationId) query.push("physicalLocationId=" + physicalLocationId);
	let queryString = query.join("&");
	return useAxiosGet<InitialAppDataResponse>(`/InitialAppData${(queryString ? "?" + queryString : "")}`, manual ?? false);
}
